import { useRef } from "react";
import { motion, useInView, useScroll, useTransform } from "framer-motion";

export const EASE = [0.83, 0, 0.17, 1];

export function MaskedLine({ children, delay = 0, className = "", inView = false }) {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-8%" });
  const animate = inView ? (seen ? { y: "0%" } : {}) : { y: "0%" };
  return (
    <span ref={ref} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
      <motion.span
        className={`block will-change-transform ${className}`}
        initial={{ y: "112%" }}
        animate={animate}
        transition={{ duration: 1.15, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function FadeUp({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function ParallaxImage({ src, alt, className = "", speed = 10, imgClassName = "", position = "center" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed}%`, `${speed}%`]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y, objectPosition: position }}
        className={`h-[115%] w-full scale-[1.12] object-cover ${imgClassName}`}
      />
    </div>
  );
}

export function Page({ children, testId }) {
  return (
    <motion.main
      data-testid={testId}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: EASE }}
      className="min-h-screen"
    >
      {children}
    </motion.main>
  );
}

export function Meta({ children, className = "" }) {
  return (
    <p className={`text-xs font-medium uppercase tracking-[0.25em] text-ash ${className}`}>
      {children}
    </p>
  );
}
